import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class GetUserCountryIpService {

  constructor(private httpClient: HttpClient) {
  }
  getCountryIP(): Observable<any> {
    return this.httpClient.get(environment.currentHostPath + '/client_ip');
  }
}
